// extracted by mini-css-extract-plugin
export default {"social":"components-Footer-themes-PP-social__social--nmXF7","title":"components-Footer-themes-PP-social__title--HbViK","icons":"components-Footer-themes-PP-social__icons--jMHiL"};